import { insertStringAt } from "../../../../../shared";

export function formatPin(pin: string | number): string {
  return insertStringAt(String(pin), 3, "-");
}
